'use strict';

define('quick-contact',['jquery'], function ($) {

  var
    $quickContactContainer    = $('.quick-contact'),
    $quickContactButtonOpen   = $('.js-quick-contact-open'),
    $quickContactButtonClose  = $('.js-quick-contact-close');

  var
    IS_ACTIVE = 'is-active';

  var attachEvents = function() {
    $quickContactButtonOpen.on('click', function() {
      $quickContactContainer.addClass(IS_ACTIVE);
    });

    $quickContactButtonClose.on('click', function() {
      $quickContactContainer.removeClass(IS_ACTIVE);
      cleanUpForm();
    });
  };

  var cleanUpForm = function() {
    $quickContactContainer.find('input[type="text"], textarea').val('').focus().blur();
  };

  var initialize = function() {
    attachEvents();
  };

  return {
    init: initialize
  };
});
